var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___a0JoaG",
  "KR": "TextualAttachmentPreview.module__previewSurface___a0JoaG",
  "cA": "TextualAttachmentPreview.module__previewActions___a0JoaG",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___a0JoaG",
  "VA": "TextualAttachmentPreview.module__previewActionButton___a0JoaG" + " " + __webpack_require__(180357)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___a0JoaG",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___a0JoaG",
  "vd": "TextualAttachmentPreview.module__previewViewport___a0JoaG",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___a0JoaG",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___a0JoaG",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___a0JoaG",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___a0JoaG",
  "uT": "TextualAttachmentPreview.module__previewCode___a0JoaG",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___a0JoaG",
  "VP": "TextualAttachmentPreview.module__previewError___a0JoaG",
  "Ml": "TextualAttachmentPreview.module__loadingState___a0JoaG",
  "qr": "TextualAttachmentPreview.module__footer___a0JoaG",
  "X1": "TextualAttachmentPreview.module__expandButton___a0JoaG" + " " + __webpack_require__(180357)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___a0JoaG",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___a0JoaG",
  "qt": "TextualAttachmentPreview.module__fileSection___a0JoaG",
  "gM": "TextualAttachmentPreview.module__fileMeta___a0JoaG",
  "Md": "TextualAttachmentPreview.module__fileName___a0JoaG",
  "Ov": "TextualAttachmentPreview.module__fileSize___a0JoaG",
  "zt": "TextualAttachmentPreview.module__footerActions___a0JoaG",
  "uH": "TextualAttachmentPreview.module__controlButton___a0JoaG" + " " + __webpack_require__(180357)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___a0JoaG",
  "tP": "TextualAttachmentPreview.module__languagePopup___a0JoaG",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___a0JoaG",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___a0JoaG",
  "qm": "TextualAttachmentPreview.module__languageEmpty___a0JoaG",
  "xl": "TextualAttachmentPreview.module__languageList___a0JoaG",
  "O6": "TextualAttachmentPreview.module__languageItem___a0JoaG",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___a0JoaG",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___a0JoaG",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___a0JoaG",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___a0JoaG",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___a0JoaG",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___a0JoaG",
  "CR": "TextualAttachmentPreview.module__modalRoot___a0JoaG",
  "Ij": "TextualAttachmentPreview.module__modalLayout___a0JoaG",
  "S3": "TextualAttachmentPreview.module__modalBody___a0JoaG",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___a0JoaG",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___a0JoaG",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___a0JoaG",
};

module.exports = exports;
